import React from 'react';

import * as S from './Count.styles';

interface CountProps {
  count: number;
}

export const Count = ({ count }: CountProps) => {
  if (count < 0) {
    return null;
  }

  return (
    <S.MoreInsights>
      <S.Count aria-label={`${count} more items`}>{`+ ${count}`}</S.Count>
    </S.MoreInsights>
  );
};
